import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import { Box, Typography, useMediaQuery, useTheme } from "@mui/material";
import { EText } from "../event/typography/EText";
export const SteperHeader = ({ title, titleOptional, description, removeBackground = false, }) => {
    const theme = useTheme();
    const isMd = useMediaQuery(theme.breakpoints.down("lg"));
    return (_jsxs(Box, { sx: {
            backgroundColor: removeBackground ? "transparent" : "#FFFFFF",
            left: 0,
            top: 0,
            pt: removeBackground ? 0 : 3,
            zIndex: 10,
            width: "100%",
            display: 'flex',
            flexDirection: 'column',
            gap: 3,
        }, children: [_jsxs(EText, { fontWeight: 500, variant: removeBackground ? "subtitle1" : "h4", color: "#00244D", children: [title, titleOptional && (_jsxs("span", { style: { color: "#637381" }, children: ["(", titleOptional, ")"] }))] }), description && (_jsx(Typography, { variant: "body1", color: "#00244D", children: description }))] }));
};
